module.exports = __webpack_public_path__ + "img/share-tip.c6095fd6.png";